export default __webpack_public_path__ + "static/media/icons8-visa.77d6f52e.svg";